import { WHITE_COLOR } from "../resources/colorsManager";
import Navbar from "./Navbar";

const Centered = ({ children }) => (
  <div
    style={{
      width: "100%",
      backgroundColor: WHITE_COLOR,
    }}
  >
    <Navbar />
    {children}
  </div>
);

export default Centered;
